import axios from "axios";
import { broadcastLogout, installAuthSync } from "@/lib/authSync";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// v2.7.63+E46.5 · Install cross-tab auth sync exactly once per module load.
installAuthSync({ scope: "driver" });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("rtg_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// v2.7.65+E194 · Same driver-app whitelist used in authSync.js. The
// driver 401 interceptor MUST only redirect when a real driver-app
// route emits the 401 — never on marketing pages, admin pages, or
// unknown paths, because a shared background widget (chatbot, install
// banner, map poll, etc.) 401'ing on a public marketing page would
// otherwise force-refresh an anonymous visitor to /login.
const _DRIVER_APP_PREFIXES = [
  "/dashboard", "/city", "/new-trip", "/queue", "/custom",
  "/meter", "/meter-statewide", "/trips", "/fleet", "/profile",
  "/earnings", "/end-of-day", "/delivery/active", "/onboarding/contractor-setup",
];
function _onDriverAppRoute() {
  if (typeof window === "undefined") return false;
  const p = window.location.pathname || "";
  if (p.startsWith("/admin")) return false;
  return _DRIVER_APP_PREFIXES.some((pref) =>
    p === pref || p.startsWith(pref + "/") || p.startsWith(pref)
  );
}

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status !== 401) return Promise.reject(err);
    // Only redirect when the current route is a REAL driver-app route.
    // Marketing pages, admin routes, and anonymous browsing must never
    // be kicked to /login by a background axios 401.
    if (!_onDriverAppRoute()) {
      return Promise.reject(err);
    }
    localStorage.removeItem("rtg_token");
    localStorage.removeItem("rtg_driver");
    // v2.7.63+E46.5 · notify sibling tabs before we redirect ourselves
    broadcastLogout("driver");
    if (window.location.pathname !== "/login") {
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;
